<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import request from '@/services/request';

import ModalFormComponent from '@/components/payroll/ModalFormComponent.vue';
import Catalogue from '@/services/catalogue';

import Pagination from 'vue-pagination-2';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
	name: "payroll-table",
	components: {
		ModalFormComponent,
		DatePicker,
		Pagination,
	},
	data() {
		return {
			loadAll: false,
			payrolls: [],
			payrolls_p: [],
			payrolls_s: [],
			// partners: [],
			// partners_p: [],
			// partners_s: [],
			// checks: [],
			// checks_p: [],
			// checks_s: [],
			name: '',
			editPayroll: true,
			trigger:true,
			init:false,
			search: {
				date: '',
				company_id: '',
				authorized: 1,
			},
			order:{
				id:-1,
				name:-1,
				amount:-1,
				paid:-1,
				retention:-1,
				date_start:0,
				date_end:-1,
				approved:-1,
				status:-1,
			},
			idConvert: '',
			idUser: '',
			page: 1,
			per_page: 10,
			send: false,
			catalogue: new Catalogue(),
			load: false,
			isExpanded: []
		}
	},
	async mounted() {
		this.loadAll = true;

		this.catalogue.get_users_profile(2);
		if(this.authUser.organization_charts_id == 10 || this.authUser.organization_charts_id == 15){ 
            this.catalogue.get_companies_users(this.authUser.id);
        }else{
            this.catalogue.get_company_pays();
        }
		this.catalogue.get_all_billing_data();

		this.list();
		this.setHeaderTitle('Nominas');
		this.loadAll = false;

	},
	created() {
		Event.$on("event-load-payroll", () => {
			this.list();
		});
	},
	methods: {
		approve(payroll) {
			let tit = 'Aprobar Nómina';
			let txt = 'Seguro que quiere aprobar la nómina';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then(async (result) => {
				if (result.isConfirmed) {
					let _endpoint = '/payroll_approve';
					let form = {
						id: payroll.id
					};
					try {
						let response = await request.post(_endpoint, form).then(function (response) { return response; });
						this.list();
						this.successNotification(response.data.message);
						Event.$emit('event-load-checks-payrolls');
					} catch (error) {
						this.errors = await this.errorNotification(error)
					}
				}
			});

		},
		async newPayroll(account = {}, edit = true) {
			this.editPayroll = edit;
			Event.$emit('event-show-addPayroll', account);
		},
		deleted: function (id) {
			let tit = 'Eliminar Nomina';
			let txt = 'Seguro que quiere eliminar la Nomina';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then((result) => {
				if (result.isConfirmed) {
					this.callDeleted(id);
				}
			});
		},
		async callDeleted(id) {
			let _endpoint = '/payroll/' + id;
			try {
				let response = await request.destroy(_endpoint).then(function (response) { return response; });
				this.list();
				this.successNotification(response.data.message);
			} catch (error) {
				this.errors = await this.errorNotification(error)
			}
		},
		async changePage(page = 1){
			// if(this.view==1)
				this.payrolls_s=this.payrolls_p[page-1];
			// else if (this.search.authorized==0)
			// 	this.checks_s=this.checks_p[page-1];
			// else
			// 	this.partners_s=this.partners_p[page-1];
		},
		async sortPage(name){
			switch(name){
				case 'id':
					this.order.id++;
					if(this.order.id%2==0)
						// if(this.view==1)
							this.payrolls=this.payrolls.sort((a,b)=>{
								return a.id - b.id
							});
						// else
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return a.id - b.id
						// 	});
					else
						// if(this.view==1)
							this.payrolls=this.payrolls.sort((a,b)=>{
								return b.id - a.id
							});
						// else
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return b.id - a.id
						// 	});
					this.order.name=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.retention=-1;
					this.order.date_start=-1;
					this.order.date_end=-1;
					this.order.approved=-1;
					this.order.status=-1;
				break;
				case 'name':
					this.order.name++;
					if(this.order.name%2==0)
						// if(this.view==1)
							this.payrolls=this.payrolls.sort((a,b)=>{
								return a.company.name.localeCompare(b.company.name)
							});
						// else if (this.search.authorized==0){
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return a.user.name.localeCompare(b.user.name)
						// 	});
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return a.payroll.company.name.localeCompare(b.payroll.company.name)
						// 	});
						// }else{
						// 	this.partners=this.partners.sort((a,b)=>{
						// 		return a.user.name.localeCompare(b.user.name)
						// 	});
						// 	this.partners=this.partners.sort((a,b)=>{
						// 		return a.payroll.company.name.localeCompare(b.payroll.company.name)
						// 	});
						// }
					else
						// if(this.view==1)
							this.payrolls=this.payrolls.sort((a,b)=>{
								return b.company.name.localeCompare(a.company.name)
							});
						// else if (this.search.authorized==0){
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return b.user.name.localeCompare(a.user.name)
						// 	});
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return b.payroll.company.name.localeCompare(a.payroll.company.name)
						// 	});
						// }else{
						// 	this.partners=this.partners.sort((a,b)=>{
						// 		return b.user.name.localeCompare(a.user.name)
						// 	});
						// 	this.partners=this.partners.sort((a,b)=>{
						// 		return b.payroll.company.name.localeCompare(a.payroll.company.name)
						// 	});
						// }
					this.order.id=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.retention=-1;
					this.order.date_start=-1;
					this.order.date_end=-1;
					this.order.status=-1;
					this.order.approved=-1;
				break;
				case 'amount':
					this.order.amount++;
					if(this.order.amount%2==0)
						// if(this.view==1)
							this.payrolls=this.payrolls.sort((a,b)=>{
								return a.amount- b.amount
							});
						// else if (this.search.authorized==0)
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return a.amount- b.amount
						// 	});
						// else
						// 	this.partners=this.partners.sort((a,b)=>{
						// 		return a.amount - b.amount
						// 	});
					else
						// if(this.view==1)
							this.payrolls=this.payrolls.sort((a,b)=>{
								return b.amount- a.amount
							});
						// else if (this.search.authorized==0)
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return b.amount- a.amount
						// 	});
						// else
						// 	this.partners=this.partners.sort((a,b)=>{
						// 		return b.amount - a.amount
						// 	});
					this.order.id=-1;
					this.order.name=-1;
					this.order.paid=-1;
					this.order.retention=-1;
					this.order.date_start=-1;
					this.order.date_end=-1;
					this.order.status=-1;
					this.order.approved=-1;
				break;
				case 'paid':
					this.order.paid++;
					if(this.order.paid%2==0)
						// if(this.view==1)
							this.payrolls=this.payrolls.sort((a,b)=>{
								return (a.pays_sum_amount??0)- (b.pays_sum_amount??0)
							});
						// else 
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return a.sum_pays- b.sum_pays
						// 	});
					else
						// if(this.view==1)
							this.payrolls=this.payrolls.sort((a,b)=>{
								return (b.pays_sum_amount??0)- (a.pays_sum_amount??0)
							});
						// else 
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return b.sum_pays- a.sum_pays
						// 	});
					this.order.id=-1;
					this.order.name=-1;
					this.order.amount=-1;
					this.order.retention=-1;
					this.order.date_start=-1;
					this.order.date_end=-1;
					this.order.status=-1;
					this.order.approved=-1;
				break;
				// case 'retention':
				// 	this.order.retention++;
				// 	if(this.order.retention%2==0)
				// 		this.partners=this.partners.sort((a,b)=>{
				// 			return a.retention - b.retention
				// 		});
				// 	else
				// 		this.partners=this.partners.sort((a,b)=>{
				// 			return b.retention - a.retention
				// 		});
				// 	this.order.id=-1;
				// 	this.order.amount=-1;
				// 	this.order.paid=-1;
				// 	this.order.name=-1;
				// 	this.order.date=-1;
				// 	this.order.approved=-1;
				// break;
				case 'date_start':
					this.order.date_start++;
					if(this.order.date_start%2==0)
						// if(this.view==1)
							this.payrolls=this.payrolls.sort((a,b)=>{
								return new Date(a.date_start) - new Date(b.date_start)
							});
						// else if (this.search.authorized==0)
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return new Date(a.payroll.date) - new Date(b.payroll.date)
						// 	});
						// else
						// 	this.partners=this.partners.sort((a,b)=>{
						// 		return new Date(a.payroll.date) - new Date(b.payroll.date)
						// 	});
					else
						// if(this.view==1)
							this.payrolls=this.payrolls.sort((a,b)=>{
								return new Date(b.date_start) - new Date(a.date_start)
							});
						// else if (this.search.authorized==0)
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return new Date(b.payroll.date) - new Date(a.payroll.date)
						// 	});
						// else
						// 	this.partners=this.partners.sort((a,b)=>{
						// 		return new Date(b.payroll.date) - new Date(a.payroll.date)
						// 	});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.retention=-1;
					this.order.name=-1;
					this.order.date_end=-1;
					this.order.status=-1;
					this.order.approved=-1;
				break;
				case 'date_end':
					this.order.date_end++;
					if(this.order.date_end%2==0)
						// if(this.view==1)
							this.payrolls=this.payrolls.sort((a,b)=>{
								return new Date(a.date_end) - new Date(b.date_end)
							});
						// else if (this.search.authorized==0)
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return new Date(a.payroll.date) - new Date(b.payroll.date)
						// 	});
						// else
						// 	this.partners=this.partners.sort((a,b)=>{
						// 		return new Date(a.payroll.date) - new Date(b.payroll.date)
						// 	});
					else
						// if(this.view==1)
							this.payrolls=this.payrolls.sort((a,b)=>{
								return new Date(b.date_end) - new Date(a.date_end)
							});
						// else if (this.search.authorized==0)
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return new Date(b.payroll.date) - new Date(a.payroll.date)
						// 	});
						// else
						// 	this.partners=this.partners.sort((a,b)=>{
						// 		return new Date(b.payroll.date) - new Date(a.payroll.date)
						// 	});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.retention=-1;
					this.order.name=-1;
					this.order.date_start=-1;
					this.order.status=-1;
					this.order.approved=-1;
				break;
				case 'approved':
					this.order.approved++;
					if(this.order.approved%2==0)
						// if(this.view==1){
							this.payrolls=this.payrolls.sort((a,b)=>{
								return (a.checks_sum_amount??0) - (b.checks_sum_amount??0)
							});
						// }else 
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return new Date(a.authorization_date) - new Date(b.authorization_date)
						// 	});
					else
						// if(this.view==1)
							this.payrolls=this.payrolls.sort((a,b)=>{
								return (b.checks_sum_amount??0) - (a.checks_sum_amount??0)
							});
						// else 
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return new Date(b.authorization_date) - new Date(a.authorization_date)
						// 	});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.retention=-1;
					this.order.name=-1;
					this.order.date_start=-1;
					this.order.date_end=-1;
					this.order.status=-1;
				break;
				case 'status':
					this.order.status++;
					if(this.order.status%2==0)
						// if(this.view==1){
							this.payrolls=this.payrolls.sort((a,b)=>{
								return (a.checks.length??0) - (b.checks.length??0)
							});
						// }else 
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return new Date(a.authorization_date) - new Date(b.authorization_date)
						// 	});
					else
						// if(this.view==1)
							this.payrolls=this.payrolls.sort((a,b)=>{
								return (b.checks.length??0) - (a.checks.length??0)
							});
						// else 
						// 	this.checks=this.checks.sort((a,b)=>{
						// 		return new Date(b.authorization_date) - new Date(a.authorization_date)
						// 	});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.retention=-1;
					this.order.name=-1;
					this.order.date_start=-1;
					this.order.date_end=-1;
					this.order.approved=-1;
				break;
			}
		},
		async list() {
			this.order={
				id:-1,
				name:-1,
				amount:-1,
				paid:-1,
				retention:-1,
				date_start:0,
				date_end:-1,
				status:-1,
				approved:-1,
			};
			this.init=false;
			this.load = true;
			this.payrolls=[];
			this.page=1;
			let service = request;
			let search = this.search;
			let _endpoint = '/payroll';
			search.search = this.name;
			try {
				let { data } = await service.list(_endpoint, this.page, search)
				if (data) {
					this.init=(this.search.date == '' || this.search.date[0]==null) &&
						this.search.company_id == '';
					this.payrolls = data.data;
					this.sortPage('date_start');
					if(data.dates[0]!=''){
						this.trigger=false;
						this.search.date = data.dates;
					}
				}
			} catch (error) {
				console.log(error);
			} finally{
				this.load = false;
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			resetPassword: 'auth/resetPass',
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	},
	watch: {
		'payrolls': {
			handler: function () {
				if(this.payrolls.length>0){
					let vm=this,k=0,j=1;
					this.payrolls_p=[];
					this.payrolls_p[0]=[];
					this.payrolls.forEach(s=>{
						vm.payrolls_p[k].push(s);
						if(j%vm.per_page==0){
							k++;
							vm.payrolls_p[k]=[];
						}
						j++;

					});
					this.payrolls_s=this.payrolls_p[this.page-1];
				}else{
					this.payrolls_p=[];
					this.payrolls_s=[];
				}
			},
			deep: true
		},
		'per_page': {
			handler: function () {
				this.page=1;
				if(this.payrolls.length>0){
					let vm=this,k=0,j=1;
					this.payrolls_p=[];
					this.payrolls_p[0]=[];
					this.payrolls.forEach(s=>{
						vm.payrolls_p[k].push(s);
						if(j%vm.per_page==0){
							k++;
							vm.payrolls_p[k]=[];
						}
						j++;

					});
					this.payrolls_s=this.payrolls_p[this.page-1];
				// } else if(this.checks.length>0){
				// 	let vm=this,k=0,j=1;
				// 	this.checks_p=[];
				// 	this.checks_p[0]=[];
				// 	this.checks.forEach(p=>{
				// 		vm.checks_p[k].push(p);
				// 		if(j%vm.per_page==0){
				// 			k++;
				// 			vm.checks_p[k]=[];
				// 		}
				// 		j++;

				// 	});
				// 	this.checks_s=this.checks_p[this.page-1];
				// }else if(this.partners.length>0){
				// 	let vm=this,k=0,j=1;
				// 	this.partners_p=[];
				// 	this.partners_p[0]=[];
				// 	this.partners.forEach(p=>{
				// 		vm.partners_p[k].push(p);
				// 		if(j%vm.per_page==0){
				// 			k++;
				// 			vm.partners_p[k]=[];
				// 		}
				// 		j++;

				// 	});
				// 	this.partners_s=this.partners_p[this.page-1];
				}
			},
			deep: true
		},
		'name': {
			handler: function (val) {
				if (val == '') {
					this.list();
				}
			},
			deep: true
		},
		'search': {
			handler: function () {
				if(this.trigger)
					this.list();
				else
					this.trigger=true;
			},
			deep: true
		}
	},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		})
	},
}
</script>

<style scoped>
.payrolls-page {
	padding-bottom: 20px;
}

.card-header {
	padding: 16px 20px;
}

.card-title {
	font-size: 18px;
	font-weight: 600;
}

.payrolls-actions {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	align-items: center;
	justify-content: flex-end;
}

.payrolls-actions .btn {
	white-space: nowrap;
}

/* Filtros */

.filters-panel {
	padding: 18px 18px 3px;
	margin-bottom: 20px;
	background-color: #f8f9fa;
	border: 1px solid #e3e6e9;
	border-radius: 8px;
}

.filters-heading h6 {
	font-size: 16px;
	color: #2f343a;
}

.filters-panel label {
	margin-bottom: 6px;
	font-size: 13px;
	font-weight: 600;
	color: #495057;
}

.filters-grid {
	margin-right: -8px;
	margin-left: -8px;
}

.filters-grid > [class*="col-"] {
	margin-top: 0 !important;
	margin-bottom: 15px;
	padding-right: 8px;
	padding-left: 8px;
}

.filters-panel .form-control,
.filters-panel >>> .mx-input {
	height: 40px;
	font-size: 14px;
	border: 1px solid #ced4da;
	border-radius: 6px;
	background-color: #ffffff;
	box-shadow: none;
}

.filters-panel .form-control:focus,
.filters-panel >>> .mx-input:focus {
	border-color: #80bdff;
	box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.08);
}

.search-input-wrapper {
	position: relative;
}

.search-input-wrapper > i {
	position: absolute;
	top: 50%;
	left: 13px;
	z-index: 2;
	color: #6c757d;
	font-size: 13px;
	transform: translateY(-50%);
	pointer-events: none;
}

.search-input-wrapper .form-control {
	padding-left: 36px;
}

.date-filter,
.date-filter >>> .mx-datepicker {
	width: 100%;
}

.default-period-badge {
	display: inline-flex;
	align-items: center;
	padding: 5px 9px;
	color: #856404;
	background-color: #fff3cd;
	border: 1px solid #ffe69c;
	border-radius: 14px;
	font-size: 11px;
	font-weight: 600;
	white-space: nowrap;
}

.complement-filter {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	height: 40px;
	margin-top: 25px !important;
	border: 1px solid #ced4da;
	border-radius: 6px;
	background-color: #ffffff;
	color: #495057;
	font-size: 13px;
	font-weight: 600;
}

.complement-filter:hover {
	color: #0056b3;
	background-color: #f3f7fc;
	border-color: #80bdff;
}

.complement-filter.active {
	color: #0056b3;
	background-color: #e7f1ff;
	border-color: #4b72d9;
}

/* Tarjetas de resumen */

.payrolls-summary {
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	gap: 17px;
	margin-bottom: 20px;
}

.summary-card {
	display: flex;
	align-items: center;
	min-height: 85px;
	padding: 15px;
	background-color: #ffffff;
	border: 1px solid #e5e7eb;
	border-left: 4px solid #6c757d;
	border-radius: 8px;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.04);
}

.summary-icon {
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 44px;
	width: 44px;
	height: 44px;
	margin-right: 13px;
	font-size: 18px;
	color: #2f343a;
	background-color: #f1f3f5;
	border-radius: 50%;
}

.summary-card span {
	display: block;
	margin-bottom: 1px;
	font-size: 12px;
	color: #6c757d;
	text-transform: uppercase;
	letter-spacing: 0.3px;
}

.summary-card strong {
	display: block;
	font-size: 22px;
	line-height: 1.1;
	color: #212529;
	word-break: break-word;
}

.summary-total {
	border-left-color: #6c757d;
}

.summary-amount {
	border-left-color: #28a745;
}

.summary-pending {
	border-left-color: #ffc107;
}

.summary-paid {
	border-left-color: #4b72d9;
}

/* Tabla */

.table-container {
	overflow: hidden;
	border: 1px solid #dee2e6;
	border-radius: 8px;
}

.payrolls-table-wrapper {
	position: relative;
	/* height: clamp(420px, calc(100vh - 560px), 760px); */
	max-height: 420px;
	overflow-x: auto !important;
	overflow-y: auto !important;
	overscroll-behavior: contain;
	scrollbar-gutter: stable;
}

.payrolls-table {
	width: 100%;
	min-width: 1320px;
	margin-bottom: 0;
	table-layout: fixed;
	border-collapse: separate;
	border-spacing: 0;
}

.payrolls-table thead th {
	position: sticky;
	top: 0;
	z-index: 20;
	padding: 12px 8px;
	vertical-align: middle;
	font-size: 12px;
	font-weight: 700;
	color: #343a40;
	background-color: #f1f3f5;
	border-bottom: 2px solid #d9dde1;
	text-transform: uppercase;
	box-shadow: 0 2px 0 #d9dde1;
}

.payrolls-table tbody td {
	padding: 11px 8px;
	vertical-align: middle;
	font-size: 12px;
	line-height: 1.45;
	background-color: #ffffff;
}

.payrolls-table tbody tr {
	transition: background-color 0.15s ease;
}

.payrolls-table tbody tr:hover td {
	background-color: #f8fafc !important;
}

.payroll-row td:first-child {
	border-left: 4px solid #6c757d;
}

.check-row td:first-child {
	border-left: 4px solid #6c757d;
}

.partner-row td:first-child {
	border-left: 4px solid #6c757d;
}

.data-column {
	width: 390px;
}

.amount-column {
	width: 140px;
}

.date-column {
	width: 160px;
}

.actions-column {
	width: 310px;
}

.check-column {
	width: 70px;
}

.payment-id-cell {
	font-size: 14px !important;
	font-weight: 700;
}

.payment-id {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 40px;
	min-height: 30px;
	padding: 4px 8px;
	color: #343a40;
	background-color: #f1f3f5;
	border-radius: 6px;
}

.data-cell {
	color: #495057;
}

.data-cell > span {
	display: block;
}

.data-cell strong {
	color: #2f343a;
	font-weight: 600;
}

.data-cell hr {
	margin: 9px 0;
	border-top-color: #e3e6e9;
}

.amount-cell,
.pending-cell,
.paid-cell {
	font-size: 13px !important;
	font-weight: 600;
	font-variant-numeric: tabular-nums;
	white-space: nowrap;
}

.amount-payable-cell,
.pending-cell {
	color: #856404;
}

.amount-paid-cell,
.paid-cell {
	color: #1d7a36;
}

.date-cell {
	font-size: 12px !important;
	color: #6c757d;
}

.actions-cell {
	padding: 9px !important;
}

.actions-wrap {
	display: flex;
	flex-wrap: wrap;
	gap: 5px;
	align-items: center;
	justify-content: center;
}

.actions-wrap .d-inline {
	display: contents !important;
}

.actions-wrap hr {
	flex: 0 0 100%;
	width: 100%;
	margin: 3px 0;
	border-top-color: #e1e5e9;
}

.actions-wrap .btn,
.actions-wrap a.btn {
	margin: 0 !important;
	padding: 5px 8px;
	border-radius: 6px;
	/* background-color: #ffffff; */
	font-size: 11px;
	font-weight: 500;
	line-height: 1.3;
	white-space: normal;
	box-shadow: none;
}

/* .actions-wrap .btn-outline-light {
	color: #6c757d;
	border-color: #6c757d;
}

.actions-wrap .btn-outline-light:hover {
	color: #ffffff;
	background-color: #6c757d;
} */

.table-state {
	height: 250px;
	padding: 0 !important;
}

.loading-state,
.empty-state {
	padding: 50px 20px;
	text-align: center;
}

.loading-state i,
.empty-state i {
	margin-bottom: 12px;
	font-size: 36px;
	color: #adb5bd;
}

.loading-state h5,
.empty-state h5 {
	margin-bottom: 4px;
	font-size: 15px;
	font-weight: 600;
	color: #343a40;
}

.loading-state p,
.empty-state p {
	margin-bottom: 0;
	font-size: 12px;
	color: #6c757d;
}

.totals-row td {
	position: sticky;
	bottom: 0;
	z-index: 4;
	padding: 12px 8px;
	font-weight: 700;
	color: #343a40;
	background-color: #e9ecef !important;
	border-top: 2px solid #ced4da;
	font-variant-numeric: tabular-nums;
}

.pagination-wrapper {
	display: flex;
	justify-content: flex-end;
	padding: 13px 16px;
	background-color: #ffffff;
	border-top: 1px solid #dee2e6;
}

.pagination-wrapper >>> .pagination {
	margin-bottom: 0;
}

.selected td {
	background-color: #f1f5ff !important;
}

.selected td:first-child {
	border-left-color: #4b72d9;
}

/* Modal de tipo de pago */

.btn-app {
	margin: 0;
	height: 80px;
}

.f-30 {
	font-size: 30px;
}

.payment-type-modal >>> .v--modal {
	border-radius: 8px;
	overflow: visible;
}

.payment-type-modal .modal-header {
	padding: 18px 20px 8px;
	border-bottom: 0;
}

.payment-type-modal .modal-title {
	margin-bottom: 0;
	font-size: 17px;
	font-weight: 600;
}

.modal-subtitle {
	margin: 4px 0 0;
	font-size: 12px;
	color: #6c757d;
}

.payment-type-modal .modal-body {
	padding: 10px 20px 20px;
}

.payment-type-modal .btn-closed {
	position: absolute;
	top: 10px;
	right: 10px;
	z-index: 4;
	width: 30px;
	height: 30px;
	padding: 0;
	border-radius: 50%;
}

.payment-option-btn {
	display: flex !important;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 7px;
	height: 90px !important;
	border: 1px solid #dee2e6;
	border-radius: 8px;
	background-color: #f8f9fa;
	color: #343a40;
	font-size: 12px;
	font-weight: 600;
}

.payment-option-btn:hover {
	color: #0056b3;
	background-color: #eef5ff;
	border-color: #80bdff;
}

/* Responsive */

@media (max-width: 1199px) {
	.payrolls-summary {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.payrolls-table-wrapper {
		height: 60vh;
		max-height: 420px;
	}
}

@media (max-width: 767px) {
	.card-header {
		padding: 14px;
	}

	.card-body {
		padding: 14px;
	}

	.payrolls-actions {
		width: 100%;
		justify-content: flex-start;
	}

	.filters-panel {
		padding: 15px 15px 0;
	}

	.payrolls-summary {
		grid-template-columns: 1fr;
		gap: 10px;
	}

	.summary-card {
		min-height: 75px;
	}

	.pagination-wrapper {
		justify-content: center;
		overflow-x: auto;
	}

	.payrolls-table-wrapper {
		height: 65vh;
		max-height: 400px;
	}
}

@media (max-width: 575px) {
	.payrolls-actions {
		display: grid;
		grid-template-columns: 1fr;
	}

	.payrolls-actions .btn {
		width: 100%;
	}

	.filters-heading {
		align-items: flex-start !important;
		flex-direction: column;
	}

	.default-period-badge {
		white-space: normal;
	}
}
</style>

<template>
	<div class="col-12 payrolls-page">
		<div class="card card-outline card-navy">
			<div class="card-header">
				<div class="d-flex flex-wrap align-items-center justify-content-between">
					<div>
						<h3 class="card-title">
							<i class="fa-solid fa-money-check-dollar mr-2"></i>
							Lista de N&oacute;minas
						</h3>
						<br>
						<small class="text-muted d-block mt-1">
							Consulta, filtra y administra los movimientos registrados.
						</small>
					</div>
					<div class="card-tools payrolls-actions">
						<button @click="newPayroll()" v-can="'add_payroll'" class="btn btn-sm btn-outline-info">
							<i class="fa fa-plus"></i> N&oacute;mina
						</button>
					</div>
				</div>
			</div>
			<div class="card-body">
				<section class="filters-panel">
					<div class="d-flex align-items-center justify-content-between mb-3 filters-heading">
						<h6 class="mb-0 font-weight-bold">
							<i class="fa-solid fa-filter mr-1"></i>
							Filtros
						</h6>

						<span v-if="init" class="default-period-badge">
							<i class="fa-regular fa-calendar mr-1"></i>
							Periodo predeterminado
						</span>
					</div>

					<div class="row filters-grid">
						<div class="col-md-6">
							<label>Rango de fechas :</label>
							<date-picker format="YYYY-MM-DD" valueType="format" :range="true"
								v-model="search.date"></date-picker>
							<div v-if="init" class="text-danger">Periodo por Defecto</div>
						</div>
						<div class="col-md-6">
							<label>Empresa :</label>

							<select v-model="search.company_id" class="form-control" v-if="authUser.organization_charts_id != 10 && authUser.organization_charts_id != 15">
								<option value=""> Sin empresa </option>
								<option v-for="(company, index) in catalogue.company_pays" :value="company.id" :key="index">
									{{ company.name }}</option>
							</select>

							<select v-model="search.company_id" class="form-control" v-else>
								<option value=""> Sin empresa </option>
								<option v-for="(company, index) in catalogue.companies_users" :value="company.id" :key="index">
									{{ company.name }}
								</option>
							</select>
						</div>
					</div>
				</section>
				<section class="table-container results-panel">
					<div class="row">
						<div class="col-md-6">
							<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
								<li class="nav-item">
									<a class="nav-link active" @click="search.authorized = 1" data-toggle="pill" role="tab"
										aria-selected="true">Por pagar</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" @click="search.authorized = 2" data-toggle="pill" role="tab"
										aria-selected="false">Pagados</a>
								</li>
							</ul>
						</div>
						<div class="col-md-6">
							<!-- <button class="btn btn-outline-success btn-sm mr-2" v-can="'export_payroll'"
								@click="exportData()">
								<i class="fa fa-file-excel"></i> Exportar
							</button> -->
							<label>
								<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
									<li class="nav-item">
										<label class="nav-link">Resultados por P&aacute;gina:</label>
									</li>
									<li class="nav-item">
										<a class="nav-link active" @click="per_page = 10" data-toggle="pill" aria-selected="true">10</a>
									</li>
									<li class="nav-item">
										<a class="nav-link" @click="per_page = 20" data-toggle="pill" aria-selected="false">20</a>
									</li>
									<li class="nav-item">
										<a class="nav-link" @click="per_page = 50" data-toggle="pill" aria-selected="false">50</a>
									</li>
								</ul>
							</label>
						</div>
					</div>
					<div class="table-responsive payrolls-table-wrapper">
						<table class="table table-bordered text-center text-sm payrolls-table">
							<thead>
								<tr>
									<th class="check-column">ID
										<button class="btn btn-xs" @click.prevent="sortPage('id')">
											<i class="fa" :class="order.id==-1?'fa-minus':(order.id%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="data-column">Compañía
										<button class="btn btn-xs" @click.prevent="sortPage('name')">
											<i class="fa" :class="order.name==-1?'fa-minus':(order.name%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="date-column">Fecha inicio
										<button class="btn btn-xs" @click.prevent="sortPage('date_start')">
											<i class="fa" :class="order.date_start==-1?'fa-minus':(order.date_start%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="date-column">Fecha fin
										<button class="btn btn-xs" @click.prevent="sortPage('date_end')">
											<i class="fa" :class="order.date_end==-1?'fa-minus':(order.date_end%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="amount-column">Monto
										<button class="btn btn-xs" @click.prevent="sortPage('amount')">
											<i class="fa" :class="order.amount==-1?'fa-minus':(order.amount%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="date-column">Estatus
										<button class="btn btn-xs" @click.prevent="sortPage('status')">
											<i class="fa" :class="order.status==-1?'fa-minus':(order.status%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="actions-column">Opciones</th>
								</tr>
							</thead>
							<tbody v-if="load">
								<tr>
									<td align="center" colspan="7">
										<div class="loading-state">
											<i class="fa-solid fa-circle-notch fa-spin"></i>
											<h5>Cargando n&oacute;minas</h5>
											<p>Estamos consultando la informaci&oacute;n.</p>
										</div>
									</td>
								</tr>
							</tbody>
							<tbody v-else-if="payrolls_s && payrolls_s.length > 0">
								<tr class="payroll-row" :class="payroll.id == selected ? 'selected' : ''" v-for="(payroll, index) in payrolls_s" :key="index">
									<td class="check-cell">
										{{ payroll.id }}
									</td>
									<td class="data-cell">
										<span v-if="payroll.company">{{ payroll.company.name }}</span>
										<span v-else> Sin empresa </span>
									</td>
									<td class="date-cell">{{ payroll.date_start | toDateTime }}</td>
									<td class="date-cell">{{ payroll.date_end | toDateTime }}</td>
									<td class="text-right amount-cell">{{ payroll.amount | toCurrency }}</td>
									<td class="date-cell">
										<span v-if="payroll.checks.length == 0">
											Pendiente de Aprobar
										</span>
										<span v-else>
											Aprobada
										</span>
									</td>

									<td class="actions-cell">
										<div class="actions-wrap">
											<button @click="approve(payroll)" v-can="'approve_payroll'" v-if="payroll.checks.length == 0"
												class="btn m-1 btn-outline-success btn-sm">
												<i class="fas fa-check "> </i> Aprobar
											</button>

											<button @click="newPayroll(payroll, true)" v-can="'edit_payroll'"
												v-if="payroll.checks.length == 0" class="btn m-1 btn-outline-primary btn-sm">
												<i class="fas fa-edit "> </i> Editar
											</button>
											<button @click="newPayroll(payroll, false)"
												class="btn m-1 btn-outline-secondary btn-sm">
												<i class="fas fa-eye "> </i> Ver más
											</button>

											<button type="button" @click="deleted(payroll.id)" v-can="'deleted_payroll'"
												v-if="payroll.checks.length == 0" class="btn m-1 btn-outline-danger btn btn-sm ">
												<i class="fa fa-trash"></i> Eliminar
											</button>
										</div>
									</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td align="center" colspan="7">Sin resultados.</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="pagination-wrapper" v-if="payrolls_p.length">
						<pagination v-model="page" :records="parseInt(payrolls.length)" :per-page="parseInt(per_page)"
							@paginate="changePage" />
					</div>
				</section>
			</div>
		</div>
		<ModalFormComponent :prop_edit="editPayroll" />
	</div>
</template>

<style scoped>
.pagination {
	margin-bottom: 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
	{
	opacity: 0;
}
</style>
